<!-- ! Ссылки внутри сайта -->
<script>
  import { page } from '$app/stores';
  import { store, getCity } from '$client';
  export let attributes = {};
  export let href = '/';
  const { city } = store;

  $: prefix = $city.url !== getCity($page.url.origin) ? `/gorod-${$city.url}` : '';
  $: link = href.startsWith('http') ? href : prefix + href;
  $: if (link.endsWith('/') && link.length > 1) link = link.slice(0, link.length - 1);
</script>

{#if $page.url.pathname === link || attributes.disabled}
  <div class="current-location" {...attributes}><slot /></div>
{:else}
  <a {...attributes} href={link}><slot /></a>
{/if}
